import Button from "../Button";
import Image from "../Image";

const NotificationItem = ({
  id,
  userImg,
  badge,
  badgeColor,
  title,
  description,
  onClose,
}) => {
  return (
    <div className="border-b pb-2">
      <div className="flex justify-end my-1">
        <Button
          className="text-red-500 hover:text-red-700"
          onClick={() => onClose(id)}
        >
          ✖
        </Button>
      </div>

      <div className="flex items-center mb-2">
        <div className="ml-5">
          <span
            className={`inline-block px-2 py-1 text-xs rounded-full font-semibold ${badgeColor}`}
          >
            {badge}
          </span>
          <p className="font-semibold mb-1">{title}</p>
        </div>
      </div>

      <p className="text-gray-600 text-sm mb-1">{description}</p>
    </div>
  );
};

export default NotificationItem;
